import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getGameList } from '../../services'
import { GetGameListRequest, GetGameListResponse } from '@/modules/game/type'
import { GameQueryKeys } from '@/modules/game/keys'

export default function useQueryGetGameList(
	payload?: GetGameListRequest,
	props?: UseBaseQueryOptions<GetGameListResponse>,
) {
	return useQuery({
		queryKey: [GameQueryKeys.GetGameList, payload],
		queryFn: () => getGameList(payload || {}),
		...props,
	})
}
